import { render, staticRenderFns } from "./1.vue?vue&type=template&id=c1f0ce6e&scoped=true&"
var script = {}
import style0 from "./1.vue?vue&type=style&index=0&id=c1f0ce6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f0ce6e",
  null
  
)

export default component.exports